// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2aoN1","col":"styles_col__1NBkT"};